import { ErrorDialogContext } from '../../../../../components/ErrorDialog';
import { Routes } from '../../../../../constants/Routes';
import { URLSearchParamsMonad } from '../../../../../domains/base/SearchParams';
import { useContext } from '../../../../../hooks/useContext';
import { useReservationId } from '../../../../../hooks/useReservationId';
import { useTransaction } from '../../../../../hooks/useTransaction';
import { AccountDetailStore } from '../../stores/AccountDetailStore';

export const useActions = (store: AccountDetailStore, currentURL: URL) => {
  const { reservationId, push, encode } = useReservationId();
  const { setError } = useContext(ErrorDialogContext);
  const handleError = (message: string) => {
    setError({
      header: '患者プロフィールの登録に失敗しました',
      message,
      onOk: () => {
        setError();
      },
    });
  };

  const [doFix, fixStatus] = useTransaction(
    () =>
      store.updateFirstReserveProfile().then(async () => {
        const gclid = new URLSearchParams(currentURL.search).get('gclid');
        const finishParams = new URLSearchParamsMonad('')
          .acceptOptional('reservationId', reservationId ? encode(reservationId) : undefined)
          .acceptOptional('gclid', gclid ?? undefined)
          .toString();

        push(`${Routes.Paths.ReservationSuccess}?${finishParams}`, reservationId);
      }),
    (e: Error) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const gqlError: { errors?: { message: string }[] } = e as any;
      handleError(gqlError.errors?.[0]?.message || e.message);
    },
  );

  return {
    doFix,
    fixStatus,
  };
};
